module.exports = __webpack_public_path__ + "img/step1-en.bd87c522.png";